// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"b0469f1d","587":"1e8e6285","820":"525bb7fa"}[chunkId] + ".chunk.js";
};